export enum LogLabelType {
  Service = 'service',
  Component = 'component',
}
